import { render, staticRenderFns } from "./SaraiManagement.vue?vue&type=template&id=70a97013&scoped=true"
import script from "./SaraiManagement.vue?vue&type=script&lang=js"
export * from "./SaraiManagement.vue?vue&type=script&lang=js"
import style0 from "./SaraiManagement.vue?vue&type=style&index=0&id=70a97013&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a97013",
  null
  
)

export default component.exports